<template>
  <!--  서브페이지  -->
  <div id="sub_area">
    <!--비주얼 영역-->

    <div class="sub_visual">
      <div class="tit_area">
        <h2 class="tit">{{ title }}</h2>
      </div>
      <img v-if="title == '뉴스룸'" :src="require('./../../assets/img/sub/sub03_1.png')" alt="BG" />
      <img v-if="title == '홍보영상'" :src="require('./../../assets/img/sub/sub03_2.png')" alt="BG" />
    </div>

    <div class="navigation_area">
      <div class="navigation">
        <router-link to="/" class="i_home">
          <span>HOME</span>
        </router-link>

        <div
          class="item"
          :class="{ on: mainMenuShow }"
          @mouseover="mainMenuShow = true"
          @mouseleave="mainMenuShow = false"
        >
          <a>{{ title }}</a>
          <div>
            <router-link
              active-class="on"
              tag="a"
              to="/Public/News"
              @click.native="mainMenuShow = false"
              >뉴스룸</router-link
            >
            <router-link
              active-class="on"
              tag="a"
              to="/Public/PRVideo"
              @click.native="mainMenuShow = false"
              >홍보영상</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    mainMenuShow: false,
    message: "BizMain.vue",
    title: "뉴스룸"
  }),
  methods: {
    titleChange(urlPath) {
      switch (urlPath) {
        case "/Public/News":
          {
            this.title = "뉴스룸";
          }
          break;
        case "/Public/PRVideo":
          {
            this.title = "홍보영상";
          }
          break;
      }
    }
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.titleChange(to.path);
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    this.titleChange(this.$route.path);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub03/PublicMain.vue